/**
 * Reia Blog Search — pulses the submit button once the visitor has typed a
 * query, as a UX nudge that there's now something to click.
 */
(function () {
  document.querySelectorAll('[data-reia-blog-search]').forEach(function (form) {
    var input = form.querySelector('.reia-blog-search__input');
    var field = form.querySelector('.reia-blog-search__field');
    if (!input || !field) return;

    var updateActiveState = function () {
      field.classList.toggle('is-active', input.value.trim().length > 0);
    };

    input.addEventListener('input', updateActiveState);
    updateActiveState();
  });
})();
